import { render, staticRenderFns } from "./AlertCompletaPerfilInv.vue?vue&type=template&id=5c4edb44&"
import script from "./AlertCompletaPerfilInv.vue?vue&type=script&lang=ts&"
export * from "./AlertCompletaPerfilInv.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports